<template>
    <svg width="12" height="15" viewBox="0 0 12 15" xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor">
            <circle cx="1.5" cy="1.5" r="1.5" />
            <circle cx="6.5" cy="1.5" r="1.5" />
            <circle cx="1.5" cy="7.5" r="1.5" />
            <circle cx="6.5" cy="7.5" r="1.5" />
            <circle cx="1.5" cy="13.5" r="1.5" />
            <circle cx="6.5" cy="13.5" r="1.5" />
        </g>
    </svg>
</template>

<script>
    export default {
        name: 'DragIcon',
    };
</script>
